import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-mensagem',
  templateUrl: './modal-mensagem.component.html',
  styleUrls: ['./modal-mensagem.component.scss']
})
export class ModalMensagemComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalMensagemModel
  ) {}

}

export interface ModalMensagemModel {
  /** Título do modal, caso queira que seja exibido. */
  titulo?: string;
  
  /** Mensagem a ser exibida pelo modal. */
  mensagem: string;
}
